import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0b139f6f&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b139f6f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qingchi/workspace/mimi/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b139f6f')) {
      api.createRecord('0b139f6f', component.options)
    } else {
      api.reload('0b139f6f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0b139f6f&scoped=true", function () {
      api.rerender('0b139f6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/shoppingCredit/index.vue"
export default component.exports